import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id A626AD09-C436-4622-905C-9C7E8164CD54
 * name forwardburger
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forwardburger.svg
 * tags
 */
export const ForwardburgerIcon = createSvgIcon(<><path d="M19,13H3V11H19L15,7L16.4,5.6L22.8,12L16.4,18.4L15,17L19,13M3,6H13V8H3V6M13,16V18H3V16H13Z" /></>, 'ForwardburgerIcon');
export default ForwardburgerIcon